const general = [
  { kanji: "欠伸", yomi: "あくび" },
  { kanji: "鼾", yomi: "いびき" },
  { kanji: "吃驚", yomi: "びっくり" },
  { kanji: "吃逆", yomi: "しゃっくり" },
  { kanji: "嚏", yomi: "くしゃみ" },
  { kanji: "憂鬱", yomi: "ゆううつ" },
  { kanji: "躊躇", yomi: "ちゅうちょ" },
  { kanji: "髑髏", yomi: "どくろ" },
  { kanji: "轆轤", yomi: "ろくろ" },
  { kanji: "朦朧", yomi: "もうろう" },
  { kanji: "齟齬", yomi: "そご" },
  { kanji: "算盤", yomi: "そろばん" },
  { kanji: "鍵盤", yomi: "けんばん" },
  { kanji: "纏足", yomi: "てんそく" },
  { kanji: "黶", yomi: "あざ" },
  { kanji: "顰蹙", yomi: "ひんしゅく" },
  { kanji: "玉響", yomi: "たまゆら" },
  { kanji: "薄荷", yomi: "はっか" },
  { kanji: "暖簾", yomi: "のれん" },
  { kanji: "胡椒", yomi: "こしょう" },
  { kanji: "櫛", yomi: "くし" },
  { kanji: "螺鈿", yomi: "らでん" },
  { kanji: "黴", yomi: "かび" },
  { kanji: "埃", yomi: "ほこり" },
  { kanji: "盥", yomi: "たらい" },
  { kanji: "仙人掌", yomi: "さぼてん" },
  { kanji: "囲炉裏", yomi: "いろり" },
  { kanji: "鼈", yomi: "すっぽん" },
  { kanji: "瑠璃", yomi: "るり" },
  { kanji: "黒子", yomi: "ほくろ" },
  { kanji: "皺", yomi: "しわ" },
  { kanji: "縞瑪瑙", yomi: "しまめのう" },
  { kanji: "藁", yomi: "わら" },
  { kanji: "羊羹", yomi: "ようかん" },
  { kanji: "煎餅", yomi: "せんべい" },
  { kanji: "鬘", yomi: "かつら" },
  { kanji: "瘡蓋", yomi: "かさぶた" },
  { kanji: "鉈", yomi: "なた" },
  { kanji: "鍬", yomi: "くわ" },
  { kanji: "箆", yomi: "へら" },
  { kanji: "放棄", yomi: "ほうき" },
  { kanji: "脛", yomi: "すね" },
  { kanji: "嘴", yomi: "くちばし" },
  { kanji: "蕨", yomi: "わらび" },
  { kanji: "鱶鰭", yomi: "ふかひれ" },
  { kanji: "雀斑", yomi: "そばかす" },
  { kanji: "脂", yomi: "やに" },
  { kanji: "塵", yomi: "ごみ" },
  { kanji: "錨", yomi: "いかり" },
  { kanji: "槌", yomi: "つち" },
  { kanji: "鑿", yomi: "のみ" },
  { kanji: "鋏", yomi: "はさみ" },
  { kanji: "梯", yomi: "はしご" },
  { kanji: "雪洞", yomi: "ぼんぼり" },
  { kanji: "洞穴", yomi: "どうけつ" },
  { kanji: "提灯", yomi: "ちょうちん" },
  { kanji: "生憎", yomi: "あいにく" },
  { kanji: "羹", yomi: "あつもの" },
  { kanji: "所謂", yomi: "いわゆる" },
  { kanji: "蠢", yomi: "うごめ(く)" },
  { kanji: "傀儡", yomi: "かいらい" },
  { kanji: "河童", yomi: "かっぱ" },
  { kanji: "逆鱗", yomi: "げきりん" },
  { kanji: "掏摸", yomi: "すり" },
  { kanji: "籠", yomi: "かご" },
  { kanji: "鉛筆", yomi: "えんぴつ" },
  { kanji: "貼付", yomi: "ちょうふ" },
  { kanji: "臍", yomi: "へそ" },
  { kanji: "比喩", yomi: "ひゆ" },
  { kanji: "頭垢", yomi: "ふけ" },
  { kanji: "率倒", yomi: "そっとう" },
  { kanji: "麓", yomi: "ふもと" },
  { kanji: "簪", yomi: "かんざし" },
  { kanji: "嶺", yomi: "れいれい" },
  { kanji: "襖", yomi: "ふすま" },
  { kanji: "鞦韆", yomi: "ぶらんこ" },
  { kanji: "護謨", yomi: "ごむ" },
  { kanji: "撥", yomi: "ばち" },
];

export { general };

// { kanji: "", yomi: "" },
// { kanji: "", yomi: "" },
